import React, { useState } from 'react';
import '../styles/pages/Contact.scss';
import { useTranslation } from 'react-i18next';
import axios from 'axios';

const Contact = () => {
  const { t } = useTranslation();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setStatus(null);
    try {
      const response = await axios.post(`${process.env.REACT_APP_SERVER_URL}/send`, form);
      if (response.data.success) {
        setStatus({ type: 'success', message: t('contact.success', 'Votre message a été envoyé avec succès !') });
        setForm({ name: '', email: '', message: '' });
      } else {
        setStatus({ type: 'error', message: t('contact.error', "Une erreur s'est produite. Veuillez réessayer.") });
      }
    } catch (error) {
      setStatus({ type: 'error', message: t('contact.error', "Une erreur s'est produite. Veuillez réessayer.") });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contact-page">
      <h1>{t('contact.title', 'Nous contacter')}</h1>
      <p className="contact-subtitle">{t('contact.content', 'Contactez-nous dès maintenant pour déléguer vos tâches administratives.')}</p>
      <hr className="contact-divider" />
      {status && (
        <div className={`contact-status ${status.type}`}>{status.message}</div>
      )}
      <form className="contact-form" onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">{t('contact.name', 'Nom')}</label>
          <input type="text" id="name" name="name" autoComplete="off" value={form.name} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="email">{t('contact.email', 'E-mail')}</label>
          <input type="email" id="email" name="email" autoComplete="off" value={form.email} onChange={handleChange} required />
        </div>
        <div className="form-group">
          <label htmlFor="message">{t('contact.message', 'Message')}</label>
          <textarea id="message" name="message" rows={3} value={form.message} onChange={handleChange} required></textarea>
        </div>
        <button type="submit" className="submit-btn" disabled={loading}>
          {loading ? t('contact.sending', 'Envoi...') : t('contact.send', 'Envoyer')}
        </button>
      </form>
    </div>
  );
};

export default Contact;